export const THEME = {
	color: {
		// Use for colors.
		primary: 'red',
		secondary: 'green',
	},
	font: {
		// Use for font sizes.
		small: '12px',
		medium: '16px',
		large: '20px',
	},
	space: {
		// Use for margin/padding.
		small: '12px',
		medium: '16px',
		large: '20px',
	},
};
